'use client'
import classNames from 'classnames'
import { Alert, LayoutStack } from 'design-system/client'
import styles from './Messages.module.css'
import useMessageContext from './useMessageContext'
import { MessagesProps } from './types'

function Messages({ className }: MessagesProps) {
  const { messages } = useMessageContext()

  if (!messages.length) return null

  return (
    <LayoutStack className={classNames(styles.messages, className)}>
      {messages.map(({ type, id, message }) => (
        <Alert key={id} kind={type} global icon className={styles.alertMessage}>
          {message}
        </Alert>
      ))}
    </LayoutStack>
  )
}

export default Messages
